class FullWidthMedia extends HTMLElement {
  constructor() {
    super();
    this.ELM_fullWidthMediaItems = this.querySelectorAll(
      ".full-width-media__item",
    );
    this.totalMediaItems = this.ELM_fullWidthMediaItems.length;
    this.ELM_fullWidthPaginationDotsWrapper = this.querySelector(
      ".full-width-media__pagination-dots",
    );
    this.ELM_fullWidthPaginationDots = this.querySelectorAll(
      ".full-width-media__pagination-dot",
    );
    this.ELM_scrollDownBtn = this.querySelector(
      ".full-width-media__btn-scroll-down",
    );

    this.currentSlide = 0;

    this.ELM_scrollDownBtn?.addEventListener("click", () => {
      this.scrollToSlide(this.currentSlide + 1);
    });

    this.ELM_fullWidthPaginationDots.forEach((elm) => {
      elm.addEventListener("click", () => {
        const index = Number(elm.dataset.index);
        this.scrollToSlide(index);
      });
    });

    window.onscroll = () => {
      const slideHeight = this.querySelector(
        ".full-width-media__item",
      ).clientHeight;

      let slideHeightOffset = slideHeight * 0.75;

      if (window.innerWidth < 750) {
        slideHeightOffset = slideHeight;
      }
      if (this.checkVisible(this, slideHeightOffset)) {
        this.ELM_fullWidthPaginationDotsWrapper.classList.add("fadein");
      } else {
        this.ELM_fullWidthPaginationDotsWrapper.classList.remove("fadein");
      }

      if (this.checkVisible(this, slideHeight + 100)) {
        this.ELM_scrollDownBtn?.classList.add("fadein");
      } else {
        this.ELM_scrollDownBtn?.classList.remove("fadein");
      }

      this.ELM_fullWidthMediaItems.forEach((elm) => {
        if (this.checkVisible(elm, slideHeight * 0.5)) {
          this.updatePaginationDots(elm);
        }
      });
    };

    this.options = {
      root: null,
      threshold: 0.5,
    };

    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      this.options,
    );

    this.ELM_fullWidthMediaItems.forEach((element) => {
      this.observer.observe(element);
    });
  }

  scrollToSlide(index) {
    const heightElm = document.getElementById(
      "full-width-media__item-0",
    ).clientHeight;
    const offset = index * heightElm + this.offsetTop;
    window.scroll({
      top: offset,
      left: 0,
      behavior: "smooth",
    });
  }

  checkVisible(elm, offset) {
    const offsetVal = offset || 0;
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight,
    );
    return !(
      rect.bottom < offsetVal ||
      rect.top - viewHeight >= offsetVal ||
      rect.top - viewHeight > -offsetVal
    );
  }

  updatePaginationDots(elm) {
    const index = elm?.dataset?.index;
    this.currentSlide = Number(index);
    this.ELM_fullWidthPaginationDots.forEach((e, i) => {
      i === Number(index)
        ? e.classList.add("active")
        : e.classList.remove("active");
    });
  }

  autoplayVideo(entry) {
    const target = entry.target;
    if (target.childNodes.length > 10) {
      let desktopVideo, mobileVideo;
      target.childNodes.forEach((e) => {
        if (e.tagName === TAGNAMES.deferredMedia) {
          desktopVideo = e.classList.contains(
            "full-width-media__media--desktop",
          )
            ? e
            : desktopVideo;
          mobileVideo = e.classList.contains("full-width-media__media--mobile")
            ? e
            : mobileVideo;
        }
      });
      const videoToClick = window.matchMedia(
        `(max-width: ${BREAKPOINTS.desktop - 1}px)`,
      ).matches
        ? mobileVideo
        : desktopVideo;
      if (videoToClick) {
        const tags = Array.from(videoToClick.childNodes).map((e) => e.tagName);
        const index = tags.indexOf(TAGNAMES.video);
        if (index !== -1) {
          videoToClick.childNodes[index].play();
        } else {
          const btnIndex = tags.indexOf(TAGNAMES.button);
          if (btnIndex !== -1) {
            videoToClick.childNodes[btnIndex].click();
          }
        }
      }
    }
  }

  handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.autoplayVideo(entry);
      }
    });
  }
}

customElements.define("full-width-media", FullWidthMedia);
